<template>
  <div>
    <template v-if="hasLabelSlot">
      <slot name="label"></slot>
    </template>
    <template v-else>
      <label
        v-if="props.label"
        class="block text-sm font-medium text-gray-700"
        :class="props.labelClass"
      >
        <T :keyName="props.label" />
      </label>
    </template>
    <div class="relative shadow-sm">
      <div
        v-if="leadingText"
        class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
      >
        <span class="text-gray-500 sm:text-sm">{{ leadingText }}</span>
      </div>
      <input
        :type="getInputType"
        :class="inputClass"
        :placeholder="placeholder"
        :value="modelValue"
        @input="emitInput($event)"
      />
      <div
        v-if="trailingText"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <span class="text-gray-500 sm:text-sm">{{ trailingText }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "@vue/reactivity";
import { useSlots } from "vue";

const props = defineProps([
  "leadingText",
  "trailingText",
  "placeholder",
  "color",
  "small",
  "modelValue",
  "inputClass",
  "label",
  "labelClass",
  "inputType",
]);

const emits = defineEmits(["update:modelValue"]);

const slots = useSlots();

const hasLabelSlot = computed(() => {
  return !!slots.label;
});

const getInputType = computed(() => {
  return props.inputType ? props.inputType : "number";
});

const inputClass = computed(() => {
  let paddingY = props.small ? "py-1" : "py-2";
  let classes = `block w-full border-gray-300 pl-6 pr-6 focus:border-${props.color}-500 focus:ring-${props.color}-500 text-sm ${paddingY}`;
  classes = `${classes} ${props.inputClass}`;
  return classes;
});

const emitInput = (evt) => {
  emits("update:modelValue", evt.target.value);
};
</script>

<style scoped></style>
